import { __extends } from "tslib";
import { emitEvent, getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { PROFILE_CARD_CONSTANTS } from './profile-card-constants';
var ProfileCardAdapter = /** @class */ (function (_super) {
    __extends(ProfileCardAdapter, _super);
    function ProfileCardAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._fullNameElement = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.FULL_NAME);
        _this._emailElement = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.EMAIL);
        _this._avatarElement = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.AVATAR);
        _this._actionToolbar = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.ACTION_TOOLBAR);
        _this._profileButton = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.PROFILE_BUTTON);
        _this._signOutButton = getShadowElement(component, PROFILE_CARD_CONSTANTS.selectors.SIGN_OUT_BUTTON);
        return _this;
    }
    ProfileCardAdapter.prototype.emitEvent = function (type, data, bubble) {
        if (bubble === void 0) { bubble = true; }
        emitEvent(this._component, type, data, bubble);
    };
    ProfileCardAdapter.prototype.setFullName = function (value) {
        this._component.setAttribute(PROFILE_CARD_CONSTANTS.attributes.FULL_NAME, value);
        this._fullNameElement.textContent = value;
    };
    ProfileCardAdapter.prototype.setEmail = function (value) {
        this._component.setAttribute(PROFILE_CARD_CONSTANTS.attributes.EMAIL, value);
        this._emailElement.textContent = value;
    };
    ProfileCardAdapter.prototype.setAvatarText = function (value) {
        this._component.setAttribute(PROFILE_CARD_CONSTANTS.attributes.AVATAR_TEXT, value);
        this._avatarElement.text = value;
    };
    ProfileCardAdapter.prototype.setAvatarImageUrl = function (value) {
        this._component.setAttribute(PROFILE_CARD_CONSTANTS.attributes.AVATAR_IMAGE_URL, value);
        this._avatarElement.imageUrl = value;
    };
    ProfileCardAdapter.prototype.setAvatarLetterCount = function (count) {
        this._component.setAttribute(PROFILE_CARD_CONSTANTS.attributes.AVATAR_LETTER_COUNT, String(count));
        this._avatarElement.letterCount = count;
    };
    ProfileCardAdapter.prototype.setActionToolbarVisibility = function (isVisible) {
        if (isVisible) {
            this._actionToolbar.style.removeProperty('display');
        }
        else {
            this._actionToolbar.style.display = 'none';
        }
    };
    ProfileCardAdapter.prototype.setProfileButtonVisibility = function (isVisible) {
        if (isVisible) {
            this._profileButton.style.removeProperty('display');
        }
        else {
            this._profileButton.style.display = 'none';
        }
    };
    ProfileCardAdapter.prototype.setSignOutButtonVisibility = function (isVisible) {
        if (isVisible) {
            this._signOutButton.style.removeProperty('display');
        }
        else {
            this._signOutButton.style.display = 'none';
        }
    };
    ProfileCardAdapter.prototype.setProfileButtonListener = function (listener) {
        this._profileButton.addEventListener('click', listener);
    };
    ProfileCardAdapter.prototype.setSignOutButtonListener = function (listener) {
        this._signOutButton.addEventListener('click', listener);
    };
    ProfileCardAdapter.prototype.removeProfileButtonListener = function (listener) {
        this._profileButton.removeEventListener('click', listener);
    };
    ProfileCardAdapter.prototype.removeSignOutButtonListener = function (listener) {
        this._signOutButton.removeEventListener('click', listener);
    };
    ProfileCardAdapter.prototype.requestProfileButtonFocus = function () {
        var _this = this;
        window.requestAnimationFrame(function () { return _this._profileButton.focus(); });
    };
    ProfileCardAdapter.prototype.requestSignOutButtonFocus = function () {
        var _this = this;
        window.requestAnimationFrame(function () { return _this._signOutButton.focus(); });
    };
    return ProfileCardAdapter;
}(BaseAdapter));
export { ProfileCardAdapter };
